// Copyright (c) Docugami, Inc. All rights reserved.

import { NamedResource } from "networking/WorkPathApi";
import { useEffect, useMemo } from "react";
import { useSelector } from "react-redux";
import { AppState } from "store";
import { TelemetryContext, ITelemetryContext } from "telemetry/TelemetryContext";
import { useDgAuth } from "./DgAuthentication";
import { useAppSelector } from "./redux";

export function useTelemetryContext(context?: Partial<ITelemetryContext>) {
    useEffect(() => {
        if (!!context) {
            const filtered = Object.fromEntries(Object.entries(context).filter(entry => !!entry[1])) as Partial<ITelemetryContext>;
            if (Object.keys(filtered).length > 0) {
                const unregister = TelemetryContext.add(filtered);
                return () => unregister();
            }
        }
    }, [context]);
}

export function useTelemetryUserContext() {
    const currentOrgId = useSelector((state: AppState) => state.organizations.currentOrganization?.id);
    const { user } = useDgAuth();

    const context = useMemo(() => ({
        userId: user?.email,
        organizationId: currentOrgId
    }), [user?.email, currentOrgId]);

    useTelemetryContext(context);
}

export function useWorkPathTelemetryContext() {
    const currentWorkPath = useAppSelector(state => state.workPaths.currentWorkPath);

    const context: Partial<ITelemetryContext> = useMemo(() => ({
        workPathId: currentWorkPath?.id,
        workPathType: currentWorkPath?.workPathType,
        documentSetId: currentWorkPath?.clusterId,
        reportId: currentWorkPath?.resources[NamedResource.ReportId],
    }), [currentWorkPath])

    useTelemetryContext(context);
}
